import React, { useState } from "react";
import EmployeeReferralList from "./components/EmployeeReferralList";
import JobPostList from "./components/JobPostList";
import SummaryHeader from "components/header/SummaryHeader";
import CustomTabs from "components/tabs/customTab";
import TabLabel from "components/tabs/TabLabel";

const EmployeeReferral = () => {

	const [activeTab, setActiveTab] = useState("referrals");

	const tabOptions = [
		{ label: <TabLabel text="Referrals" />, value: "referrals" },
		{ label: <TabLabel text="Job Posts" />, value: "job-post" },
	];

	return (
		<div className="space-y-6">
			<SummaryHeader
				title="Employee Referrals"
				iconName="FileUser"
				description="View referred Applicants"
				color={"teal"}
			/>
			<CustomTabs
				tabs={tabOptions}
				height="h-10"
				activeTab={activeTab}
				onChange={setActiveTab}
			/>

			<>
                {activeTab === "referrals" && (
                	<EmployeeReferralList/>
                )}

                {activeTab === "job-post" && (
                    <JobPostList/>
                )}
            </>

			
	    </div>
    );
};
export default EmployeeReferral;

